import { CMSBoosterPages } from '__generatedTypes__/globalTypes'

export const LandingPagesNames: Partial<Record<CMSBoosterPages, string>> = {
  [CMSBoosterPages.HomePage]: 'Booster Prep',
  [CMSBoosterPages.Product]: 'Product',
  [CMSBoosterPages.UpgradePage]: 'Upgrade',
  [CMSBoosterPages.SuccessStory]: 'Success Stories',
  [CMSBoosterPages.CrashCourses]: 'Crash Course',
  [CMSBoosterPages.Review]: 'Reviews',
}

export const EMPTY_CARD_FILTERED_CLASS_NAME = 'testimonial-filtered-empty-card'
